"use client";

import React, {useState} from "react";
import {Container} from "@/shared/components/shared";
import {Button} from "@/shared/components/ui/button";
import Image from "next/image";
import UniversalBookingModal from "@/shared/components/ui/universal-booking-modal";

export const Benefits: React.FC = () => {
    const [isUniversalBookingOpen, setIsUniversalBookingOpen] = useState(false);

    return (
        <>
            <section>
                <Container className={'pt-12 pb-12 lg:pt-29 lg:pb-33'}>
                    <div className={'flex flex-col md:grid md:grid-flow-col'}>
                        <div className="md:col-span-2 order-1 md:order-none">
                            <h2 className={'text-custom-black text-[30px] lg:text-[70px] font-bold uppercase leading-[1.2] z-1 relative'}>
                                дарим выгоду<br/> в честь знакомства
                            </h2>
                            <h3 className={'text-custom-orange font-bold text-[64px] lg:text-[132px] uppercase leading-[1.2] size-fit mt-6 z-1 relative lg:mt-33'}>
                                2.000 ₽
                            </h3>
                        </div>
                        <div className="order-3 md:order-none md:col-span-2 flex flex-col z-1 relative mt-6 lg:mt-0">
                            <p className={'uppercase text-[18px] lg:text-[45px] leading-[1.2]'}>
                            1000 рублей за замену масла<br/>+ 50% диагностика автомобиля<br/> + визуальный чек-ап
                            </p>
                            <Button 
                                variant={'filledOrange'} 
                                className={'mt-5 lg:mt-33 font-button pt-2 lg:pt-5 pb-2 lg:pb-5 pl-12 lg:pl-44 pr-12 lg:pr-44 lg:mr-auto'}
                                onClick={() => setIsUniversalBookingOpen(true)}
                            >
                                записаться
                            </Button>
                        </div>
                        <div className="order-2 md:order-none md:row-span-3 flex justify-center items-center">
                            <Image src={'/images/benefit.png'} width={1030} height={1003} className={'w-[330px] h-[303px] lg:w-auto lg:h-auto 2xl:scale-[1.2] z-0 object-fit gift-wiggle cursor-pointer'} alt={'Подарок'}/>
                        </div>
                    </div>
                </Container>
            </section>
            <UniversalBookingModal isOpen={isUniversalBookingOpen} onClose={() => setIsUniversalBookingOpen(false)} blockName="Дарим выгоду в честь знакомства"/>
        </>
    );
};